import { render, staticRenderFns } from "./ExtraFieldNumberOptions.vue?vue&type=template&id=6765fb63"
import script from "./ExtraFieldNumberOptions.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldNumberOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6765fb63')) {
      api.createRecord('6765fb63', component.options)
    } else {
      api.reload('6765fb63', component.options)
    }
    module.hot.accept("./ExtraFieldNumberOptions.vue?vue&type=template&id=6765fb63", function () {
      api.rerender('6765fb63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ExtraFieldNumberOptions.vue"
export default component.exports